import PropTypes from 'prop-types';
import React from 'react';
import moment from 'moment';
import ConfirmDialog from 'components/ConfirmDialog';
import { RAILS_DATE } from 'config/constants';

import S from 'crewForm.scss';

const ConflictingAppointmentModal = ({ active, appts, onClose, source }) => {
  const dateFormat = RAILS_DATE;
  const parsedDates = typeof appts !== 'undefined' && appts && appts.length > 0 ? appts.map((a) => {
    const start = a.start_date;
    const startMoment = moment(start, dateFormat);
    const end = a.end_date;
    const endMoment = end ? moment(end, dateFormat) : null;
    const prefix = source === 'installer' ? `${a.assignee}: ` : '';
    return (<span key={a.assignee} className={S.mdates}>
      {(!endMoment || endMoment.isSame(startMoment, 'day')) ?
        `${prefix}${startMoment.format('MMMM Do YYYY')}` :
        `${prefix}${startMoment.format('MMMM Do YYYY')} - ${endMoment.format('MMMM Do YYYY')}`}
    </span>);
  }) : null;

  const confirmation = () => (<p>
    Can not deactivate {source} with active appointments.
    <br />
    Please check the current schedule:
    <br />
    <br />
    <span className={S.mheader}>Dates:</span>
    {parsedDates || 'No valid dates found'}
  </p>);

  return (<ConfirmDialog
    show={active}
    title="Unable to deactivate"
    confirmation={confirmation()}
    theActions={['OK']}
    okLabel="OK"
    okColor="yellow"
    proceed={onClose}
    dismiss={() => {}}
    cancel={onClose}
  />);
};

ConflictingAppointmentModal.propTypes = {
  active: PropTypes.bool,
  appts: PropTypes.arrayOf(PropTypes.string),
  onClose: PropTypes.func.isRequired,
  source: PropTypes.string,
};

ConflictingAppointmentModal.defaultProps = { active: false, dates: [], source: 'installer' };

export default ConflictingAppointmentModal;



// WEBPACK FOOTER //
// ./client/app/screens/main/screens/installers/components/conflictingAppointmentModal.jsx